import React from "react";
import { InputGroup, Form } from "react-bootstrap";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import styles from "./CustomDatePicker.module.css";
import DateRangeIcon from "@mui/icons-material/DateRange";
import "react-datetime/css/react-datetime.css";
const CustomDatePicker = ({ title, date, width, onChange, margin }) => {
  return (
    <div
      className={styles.customDatePicker}
      style={{ width: width && width, margin: margin && margin }}
    >
      <Form.Text className={styles.title}> {title}</Form.Text>

      <Datetime
        // isValidDate={valid1}
        value={date}
        timeFormat={false}
        closeOnSelect={true}
        onChange={onChange}
        // open={false}
        // disabled={true}
        renderInput={(props, openCalendar) => (
          <div className={styles.customDatePicker__inputGroup}>
            <div className={styles.customDatePicker__calendarIcon}>
              {" "}
              <DateRangeIcon />
            </div>
            <input
              className="customDatePicker__input"
              type="text"
              style={{ width: "90%", border: "none" }}
              value={
                moment(date).format("DD-MM-YYYY") === "Invalid date"
                  ? "DD-MM-YYYY"
                  : moment(date).format("DD-MM-YYYY")
              }
              onFocus={openCalendar}
              readOnly
            />
          </div>
        )}
      />
    </div>
  );
};

export default CustomDatePicker;
